import { render, staticRenderFns } from "./NewReturnPartnersModal.vue?vue&type=template&id=dbd8838c&"
import script from "./NewReturnPartnersModal.vue?vue&type=script&lang=js&"
export * from "./NewReturnPartnersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewReturnPartnersModal.vue"
export default component.exports